import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AzzurroTable, SimpleButtonComponent, TitleContentComponent } from 'ngx-zcs-components';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { IonicModule } from '@ionic/angular';
import { BlockTitleComponent } from '../components/block-title/block-title.component';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';

import { NotificationConfigurationComponent } from './notification-configuration.component';
import { EventNamePipe } from './pipes/event-name.pipe';
import { EventDescriptionPipe } from './pipes/event-description.pipe';

@NgModule({
    declarations: [
      EventDescriptionPipe,
      EventNamePipe,
      NotificationConfigurationComponent,
    ],
    imports: [
      AzzurroTable,
      BlockTitleComponent,
      CommonModule,
      FormsModule,
      IonicModule,
      MatButtonModule,
      MatCheckboxModule,
      MatChipsModule,
      MatFormFieldModule,
      MatIconModule,
      MatInputModule,
      MatListModule,
      MatPaginatorModule,
      MatSelectModule,
      MatTableModule,
      MatTooltipModule,
      ReactiveFormsModule,
      SimpleButtonComponent,
      TitleContentComponent,
    ],
    exports: [
      NotificationConfigurationComponent,
    ],
})
export class NotificationConfigurationModule { }
